<template>
  <tu-ui-icon v-if="icon" :name="icon" :size="18" class="tu-destination-icon" />
</template>

<script>
import TuUiIcon from '@/tu/components/UiIcon.vue'
import { destinationIcon } from '@/tu/utils/destinationIcons'

export default {
  name: 'TuDestinationIcon',
  components: { TuUiIcon },
  props: {
    kind: { type: String, default: '' },
    to: { type: [String, Object], default: '' }
  },
  computed: {
    icon() { return destinationIcon(this.kind, this.to) }
  }
}
</script>

<style>
.tu-destination-icon { flex: 0 0 18px; width: 18px; height: 18px; }
.tu-icon-action, .tu-icon-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.tu-icon-label { justify-content: flex-start; }
</style>
